import type { GetUsersQuery } from '__generated__/graphql';

import { useQuery } from '@apollo/client';
import { SortByInterface, UserFilters } from '__generated__/graphql';
import { useAuthContext } from 'context/auth.context';
import { GET_USERS } from 'graphql/users/queries/getUsers.gql';

const emptyOptions: GetUsersQuery['users'][number][] = [];

export const useGetUsersQuery = ({
  sortBy = { sortByColumn: 'firstName' },
  filters,
  ignorePermissions = false,
  skip = false,
}: {
  sortBy?: SortByInterface;
  filters?: UserFilters;
  ignorePermissions?: boolean;
  skip?: boolean;
}) => {
  const { userTenantId: tenantId } = useAuthContext();

  const { data, error, loading, refetch } = useQuery(GET_USERS, {
    skip: skip || !tenantId,
    variables: {
      usersInput: {
        tenantId: tenantId ?? 0,
        sortBy,
        filters,
        ignorePermissions,
      },
    },
  });

  return { users: data?.users ?? emptyOptions, loading, error, refetch };
};
